import { IResponseProps } from '@/entities/Response'
import { IAppointmentProps, IAppointmentQueryProps } from '@/entities/Appointment'

export const Types = {
  store: 'store',
  current: 'current',
  query: 'query',
  type: 'type',
  open: 'open',
  scrollTop: 'scrollTop'
}

export const path = 'appointment/'

export class Store implements FluxStandardAction<IResponseProps<IAppointmentProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IAppointmentProps>) {}
}

export class Current implements FluxStandardAction<IAppointmentProps | null> {
  type = path + Types.current
  constructor(public payload: IAppointmentProps | null) {}
}

export class Query implements FluxStandardAction<IAppointmentQueryProps> {
  type = path + Types.query
  constructor(public payload: IAppointmentQueryProps) {}
}

export class Type implements FluxStandardAction<string | null> {
  type = path + Types.type
  constructor(public payload: string | null) {}
}

export class Open implements FluxStandardAction<boolean> {
  type = path + Types.open
  constructor(public payload: boolean) {}
}

export class ScrollTop implements FluxStandardAction<number> {
  type = path + Types.scrollTop
  constructor(public payload: number) {}
}
